/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Wrapper, Header, Table, Footer, Error, Status } from '../../common/Pipeline';
import { JournalEntry, columnConfigurations } from './configs';
import { isEmpty } from '@utils/lodash';

export namespace JournalPipeline {
  export interface Props {
    openEntry: (entry: JournalEntry) => void;
    entries: JournalEntry[];
    isLoading: boolean;
    hasError: boolean;
    page: number;
    totalCount: number;
    setPage: (page: number) => void;
  }
}

export const JournalPipeline: React.FC<JournalPipeline.Props> = ({
  openEntry,
  entries,
  isLoading,
  hasError,
  page,
  totalCount,
  setPage,
}) => {
  return (
    <Wrapper>
      <Header header="Journal" />
      <Table data={entries} tableColumns={columnConfigurations} onRowClick={openEntry} />
      <Footer page={page} onPageChange={setPage} totalCount={totalCount} />
      {hasError && <Error />}
      <Status isLoading={isLoading} isEmpty={isEmpty(entries)} emptyMessage={'No journal here at the moment.'} />
    </Wrapper>
  );
};
